import { Action, createReducer, on } from '@ngrx/store';
import { historyActions } from './history.action';
import { HistoryState, historyIS } from './history.state';

const historyRegister = createReducer(
  historyIS,
  on(historyActions.setPersonIdAction, (state, { personId }) => ({
    ...state,
    personId,
  })),

  on(historyActions.setSavingAction, (state, { saving }) => ({
    ...state,
    saving,
  })),

  on(
    historyActions.setPersonalHistoriesAction,
    (state, { personalHistories }) => ({
      ...state,
      personalHistories,
    })
  ),

  on(
    historyActions.setPersonalCompleteHistoryAction,
    (state, personalCompleteHistory) => ({
      ...state,
      personalCompleteHistory,
    })
  ),

  on(historyActions.setFamilyHistoriesAction, (state, { familyHistories }) => ({
    ...state,
    familyHistories,
  })),

  on(historyActions.addToSavedAction, (state, param) => {
    const newState = { ...state };
    newState.totalSaved += param.value;
    if (
      (param.hasComplete && newState.totalSaved === 3) ||
      (!param.hasComplete && newState.totalSaved === 2)
    ) {
      newState.saving = false;
      newState.totalSaved = 0;
      newState.save = true;
    } else {
      newState.saving = true;
      newState.save = false;
    }
    return newState;
  }),

  on(historyActions.setSaveAction, (state, { save }) => ({
    ...state,
    save,
  })),

  on(historyActions.setAllDefaultAction, () => historyIS)
);

export function historyReducer(state: HistoryState, action: Action): any {
  return historyRegister(state, action);
}
